export default __webpack_public_path__ + "static/ja-b5c754d0dfc95c8f3c8666f7d5e9bb05.jpg";